import {
  SHELF_QUERY,
  resolveDensity,
  usePreferences,
} from '@/features/preferences/preferences-store'

/**
 * Whether this browser session has asked for the desk: "Full Fundus →" on the
 * shelf sets it, the desk's "Shelf" link clears it (D33, D38).
 */
const DESK_KEY = 'fundus.desk'

export function prefersDesk(): boolean {
  try {
    return sessionStorage.getItem(DESK_KEY) === '1'
  } catch {
    return false
  }
}

export function leaveShelf() {
  try {
    sessionStorage.setItem(DESK_KEY, '1')
  } catch {
    // Without session storage the desk just is not remembered.
  }
}

export function returnToShelf() {
  try {
    sessionStorage.removeItem(DESK_KEY)
  } catch {
    // Nothing to forget.
  }
}

/**
 * Whether this device, right now, is standing at the shelf: the density in
 * force is the shelf's, and the session has not asked for the desk.
 */
export function atTheShelf(): boolean {
  const { density } = usePreferences.getState()
  const narrow = globalThis.matchMedia?.(SHELF_QUERY).matches ?? false
  return resolveDensity(density, narrow) === 'shelf' && !prefersDesk()
}
